// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @28.05.2021 13:27:21

import { CVehicleBase_abstract } from './../abstract/SagaSchema/CVehicleBase_abstract';

export class CVehicleBase extends CVehicleBase_abstract {
  get icon(): string {
    return 'car';
  }
}
